module.exports = __webpack_public_path__ + "static/media/mainfarm-logo.61ec78d8.svg";